module.exports = __webpack_public_path__ + "zl5-93bbaf4e.png";